import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import authService from '../api/auth';

const VerifyEmail: React.FC = () => {
  const { key } = useParams<{ key: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!key) {
        setStatus('error');
        setMessage('Invalid verification link');
        return;
      }

      try {
        const decodedKey = decodeURIComponent(key);

        let getDataResult = null;
        try {
          getDataResult = await authService.getEmailVerificationData(decodedKey);
        } catch (error) {
        }

        const result = await authService.verifyEmail(decodedKey);

        if (result.success) {
          setStatus('success');
          setMessage('Your email has been verified successfully!');

          setTimeout(() => {
            navigate('/auth/login');
          }, 2000);
        } else {
          setStatus('error');
          setMessage(result.error?.message || 'Email verification failed');
        }
      } catch (error) {
        setStatus('error');
        setMessage('An unexpected error occurred during verification');
      }
    };

    verifyEmail();
  }, [key, navigate]);

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        {status === 'loading' && (
          <div>
            <h2>Verifying your email...</h2>
            <p>Please wait while we verify your email address.</p>
          </div>
        )}

        {status === 'success' && (
          <div>
            <h2>Email Verified!</h2>
            <p>{message}</p>
            <p>Redirecting you to login...</p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <button onClick={() => navigate('/auth/login')}>
              Go to Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
